<template>
  <button ref="btn" type="button" @click="scrollTop" :aria-label="$t('Scroll to top')">
    <div class="wrapper">
      <svg width="36" height="36" class="circle-container" xmlns="http://www.w3.org/2000/svg">
        <circle cx="18" cy="18" r="17.5" stroke-width="1" fill="transparent" />
        <circle ref="circle" cx="18" cy="18" r="17.5" stroke-width="1" fill="transparent" />
      </svg>
      <svg width="22" height="22" viewBox="0 0 26 26" class="arrow" xmlns="http://www.w3.org/2000/svg">
        <path d="M12.2246 1.08224C12.4187 0.954074 12.6826 0.975828 12.8535 1.14669L19.8535 8.14669C20.0487 8.34195 20.0487 8.65846 19.8535 8.85372C19.6582 9.04899 19.3417 9.04899 19.1464 8.85372L12.5 2.20724L5.85348 8.85372C5.65822 9.04899 5.34171 9.04899 5.14645 8.85372C4.95118 8.65846 4.95118 8.34195 5.14645 8.14669L12.1464 1.14669L12.2246 1.08224Z" />
        <path d="M12 22.2667V1.73333C12 1.32832 12.2239 1 12.5 1C12.7761 1 13 1.32832 13 1.73333V22.2667C13 22.6717 12.7761 23 12.5 23C12.2239 23 12 22.6717 12 22.2667Z" />
      </svg>
    </div>
  </button>
</template>

<script>
import updateOnScroll from 'uos'
import { ReadyHook } from 'vue-asyncready'

const circumference = 11

export default {
  name: 'Progression',
  mixins: [ReadyHook],
  methods: {
    scrollTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    }
  },
  mounted () {
    updateOnScroll(0, 1, progress => {
      if (this.$refs.circle) this.$refs.circle.style.strokeDashoffset = (circumference - circumference * progress) + 'rem'

      if (this.$refs.btn) {
        if (progress === 0) {
          this.$refs.btn.blur()
          this.$refs.btn.style.opacity = 0
          this.$refs.btn.style.pointerEvents = 'none'
        } else {
          this.$refs.btn.style.opacity = 1
          this.$refs.btn.style.pointerEvents = 'auto'
        }
      }
    })
  }
}
</script>

<style lang="scss" scoped>
@import "~theme/css/core";

button {
  position: fixed;
  z-index: 100;
  bottom: 2rem;
  right: 2rem;
  padding: 0;
  background: var(--zenith-pill-background);
  border-radius: 100%;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  border: none;
  border-radius: 100%;
  transition: all 0.2s ease-in-out;
  outline: none;
  opacity: 0;
  pointer-events: none;

  @include bp(max md) {
    display: none;
  }

  .wrapper {
    position: relative;

    .circle-container {
      transform: rotate(-90deg);

      circle {
        &:first-child{
          stroke: var(--zenith-grey-light);
        }

        &:nth-child(2){
          stroke-dasharray: 11rem;
          stroke-dashoffset: 11rem;
          stroke: var(--zenith-pill-star-color);
          will-change: stroke-dashoffset;
          transition: stroke-dashoffset 0.1s linear;
        }
      }
    }

    .arrow {
      position: absolute;
      display: block;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      fill: var(--zenith-pill-star-color);
      transition: all 0.2s ease-in-out;
    }
  }

  &:hover, &:focus, &:active {
    background: var(--zenith-pill-background-hover);

    .arrow {
      fill: var(--zenith-pill-star-color-hover);
    }
  }
}
</style>
